import { connect } from 'react-redux';
import * as actions from '../../actions/ManageActions';
import * as globalActions from '../../actions/GlobalsActions';
import * as types from '../../constants/ActionTypes';

import UserDetailsTab from '../../components/UsersTabs/UserDetailsTab';
const diff = require('deep-diff');

const mapStateToProps = (state, ownProps) => {
  let initialValues;
  let bIsSelectedIsDistributor = false;
  const user = state.leaksList.user;
  const editedUser = state.manage.selectedManageItem;
  const authorizations = state.leaksList.optionList.options.allowedAuth;
  const isCreatingUser = editedUser.id === -1;
  let customers;

  if (user.isAQS) {
    customers = state.leaksList.customers.optionsList;
  } else {
    customers = [state.leaksList.customers.optionsList.find((itrCustomer) => itrCustomer.value === user.customerId)];
  }

  if (editedUser != null && editedUser.id != -1) {
    // Editing existing user
    const editedUserObj = editedUser.item;
    initialValues = Object.assign({}, editedUserObj);
    initialValues.allowedAuth = initialValues.allowedAuth?.map((auth) => auth.value);
    bIsSelectedIsDistributor = editedUserObj.allowedAuth?.some(role => {
      return role.value == 8; // 8 is distributor
    });
  } else if (editedUser != null && editedUser.id === -1) {
    // Creating new user - check if we have cloned data
    const newUserData = editedUser.item;
    if (newUserData && Object.keys(newUserData).length > 0) {
      // We have cloned data, use it as initial values
      initialValues = Object.assign({}, newUserData);
      // Format allowedAuth for the form (extract values)
      if (initialValues.allowedAuth) {
        initialValues.allowedAuth = initialValues.allowedAuth.map((auth) => 
          typeof auth === 'object' ? auth.value : auth
        );
      }
    }
  }

  return Object.assign({}, {
    initialValues: initialValues,
    customerOptions: customers,
    authOptions: authorizations,
    newUser: isCreatingUser,
    user,
    bIsSelectedIsDistributor,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: (values, dispatch, props) => {
      const data = Object.assign({}, values, {
        newUser: props.newUser,
      })
      return dispatch(actions.updateUser(data)).then((json) => {
        if (json.status) {
          props.notify('Changes saved', 'success');
        } else {
          const operation = props.newUser ? 'creation' : 'update';
          let message = `User ${operation} failed`;
          const error = json.err;

          // Provide more specific error messages
          if (error) {
            const errorMessage = error.message || '';

            // Check for password-related errors
            if (errorMessage.toLowerCase().includes('password')) {
              message = 'Password validation failed. Please ensure your password follows the requirements and does not contain forbidden characters (+&%#?/\\<>"\' spaces|[]{}).';
            } else if (errorMessage.toLowerCase().includes('email')) {
              message = 'Email validation failed. Please check your email format.';
            } else if (props.newUser && errorMessage.toLowerCase().includes('user') && errorMessage.toLowerCase().includes('exists')) {
              message = 'A user with this email or username already exists.';
            } else if (errorMessage.toLowerCase().includes('special character') || errorMessage.toLowerCase().includes('forbidden character')) {
              message = 'Password contains forbidden characters. Avoid: + & % # ? / \\ < > " \' spaces | [ ] { }';
            } else if (errorMessage.toLowerCase().includes('validation')) {
              message = 'Validation failed. Please check all required fields and try again.';
            } else if (errorMessage) {
              message = `User ${operation} failed: ${errorMessage}`;
            } else {
              message = `User ${operation} failed. Please try again.`;
            }
          }

          props.notify(message, 'error');
        }
      }).catch((error) => {
        // Handle network errors or unexpected failures
        console.error(`User ${props.newUser ? 'creation' : 'update'} error:`, error);
        props.notify('Network error occurred. Please check your connection and try again.', 'error');
      });
    },
    openManageDistributorModal: () => {
      dispatch(actions.setOpenDistributorProjects(true));
      dispatch(actions.fetchDistributorProjects());
    },

    cloneUser: () => {
      dispatch((dispatch, getState) => {
        const state = getState();
        const selectedUser = state.manage.selectedManageItem;
        
        if (selectedUser && selectedUser.item) {
          const originalData = selectedUser.item;
          
          // Prepare cloned data with only authorization and customer info
          const clonedUserData = {
            CustomerID: originalData.CustomerID,
            allowedAuth: originalData.allowedAuth || [],
            UserName: '',
            Email: '',
            Password: '',
            FirstName: '',
            LastName: '',
            PhoneNumber: ''
          };

          // Create manage item with cloned data (instead of empty item)
          dispatch({
            type: types.ADD_NEW_MANAGE_ITEM,
            clonedData: clonedUserData
          });

          ownProps.notify('User data cloned. Please enter unique username and email for the new user.', 'info');

        }
      });
    },

    delete: () => {
      dispatch(actions.deleteUser((status) => {
        let message;
        let level;
        if (status) {
          message = 'User deleted successfully';
          level = 'success';
        } else {
          message = 'User deletion failed';
          level = 'error';
        }
        ownProps.notify(message, level);
      }));
    }
  };
};

const CUserDetailsTab = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetailsTab);

export default CUserDetailsTab;

